import { z } from 'zod';
import { LEAD_SOURCES, LEAD_STATUSES, MIN_VEHICLE_YEAR, maxVehicleYear } from '../constants.js';
import { cursorQuerySchema, nonEmptyTrimmed, optionalTrimmed, paginated, uuidSchema } from './common.js';
import { createCustomerSchema, createVehicleSchema } from './customers.js';
export const createLeadSchema = z.object({
    name: nonEmptyTrimmed(120),
    phone: optionalTrimmed(30),
    email: z.string().trim().toLowerCase().email().optional().or(z.literal('')),
    source: z.enum(LEAD_SOURCES).default('other'),
    requirement: optionalTrimmed(2000),
    vehicleYear: z.number().int().min(MIN_VEHICLE_YEAR).refine((y) => y <= maxVehicleYear(), { message: 'Enter a valid model year' }).optional(),
    vehicleMake: optionalTrimmed(60),
    vehicleModel: optionalTrimmed(60),
    vehicleColor: optionalTrimmed(60),
    assignedTo: uuidSchema.optional(),
    locationId: uuidSchema.optional(),
});
export const updateLeadSchema = z.object({
    name: nonEmptyTrimmed(120).optional(),
    phone: optionalTrimmed(30),
    email: z.string().trim().toLowerCase().email().optional().or(z.literal('')),
    source: z.enum(LEAD_SOURCES).optional(),
    status: z.enum(LEAD_STATUSES).optional(),
    requirement: optionalTrimmed(2000),
    vehicleYear: z.number().int().min(MIN_VEHICLE_YEAR).refine((y) => y <= maxVehicleYear(), { message: 'Enter a valid model year' }).optional(),
    vehicleMake: optionalTrimmed(60),
    vehicleModel: optionalTrimmed(60),
    vehicleColor: optionalTrimmed(60),
    assignedTo: uuidSchema.nullable().optional(),
    lostReason: optionalTrimmed(500),
    locationId: uuidSchema.optional(),
});
export const leadListQuerySchema = cursorQuerySchema.extend({
    status: z.enum(LEAD_STATUSES).optional(),
    source: z.enum(LEAD_SOURCES).optional(),
    assignedTo: uuidSchema.optional(),
    query: z.string().trim().max(200).optional(),
    locationId: uuidSchema.optional(),
});
export const leadListItemSchema = z.object({
    id: uuidSchema,
    name: z.string(),
    phone: z.string().nullable(),
    email: z.string().nullable(),
    source: z.enum(LEAD_SOURCES),
    status: z.enum(LEAD_STATUSES),
    requirement: z.string(),
    vehicleYear: z.number().int().nullable(),
    vehicleMake: z.string(),
    vehicleModel: z.string(),
    vehicleColor: z.string(),
    assignedTo: uuidSchema.nullable(),
    locationId: uuidSchema,
    createdAt: z.string(),
});
export const leadListResponseSchema = paginated(leadListItemSchema);
export const leadActivitySchema = z.object({
    id: uuidSchema,
    type: z.enum(['note', 'status_change', 'contact']),
    body: z.string(),
    createdBy: uuidSchema.nullable(),
    createdAt: z.string(),
});
// Photos arrive via the quote widget (embed_submissions linked by lead_id,
// §31 Phase 31-E) as short-lived signed URLs; empty for leads created in-app.
export const leadPhotoSchema = z.object({ url: z.string() });
export const leadDetailSchema = leadListItemSchema.extend({
    customerId: uuidSchema.nullable(),
    activities: z.array(leadActivitySchema),
    photos: z.array(leadPhotoSchema),
});
export const addLeadActivitySchema = z.object({
    type: z.enum(['note', 'contact']),
    body: nonEmptyTrimmed(2000),
});
export const convertLeadSchema = z.object({
    customerId: uuidSchema.optional(),
    newCustomer: createCustomerSchema.optional(),
    newVehicle: createVehicleSchema.optional(),
});
export const convertLeadResponseSchema = z.object({ quoteId: uuidSchema });
//# sourceMappingURL=leads.js.map